// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import { createProvider } from "./vue-apollo";
import gql from "graphql-tag";
import provider from "./libs/provider";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import AppHeader from "./includes/Header";
import OrgAppHeader from "./includes/OrgHeader";
import Loading from "./includes/Loading";
import Empty from "./includes/Empty";
import Filter from "./includes/Filter";
import locale from "element-ui/lib/locale/lang/en";
import GlobalEvents from "vue-global-events";
import VueBus from "./vue-bus";
import PastTense from "./filters/PastTense";
import Capitalize from "./filters/Capitalize";
import DateConvert from "./filters/DateConvert";
import TimeAndDate from "./filters/TimeAndDate";
import UnSlug from "./filters/UnSlug";
import Length from "./filters/Length";
import FriendlyType from "./filters/FriendlyType";
import FormatDateTime from "./filters/FormatDateTime";
import Bugsnag from "@bugsnag/js";
import Truncate from "./filters/Truncate";

Vue.use(VueBus);
Vue.use(ElementUI, { locale });

Vue.component("global-events", GlobalEvents);
Vue.component("empty", Empty);
Vue.component("app-header", AppHeader);
Vue.component("org-app-header", OrgAppHeader);
Vue.component("result-filter", Filter);
Vue.component("loading", Loading);

Vue.filter("capitalize", Capitalize);
Vue.filter("date_convert", DateConvert);
Vue.filter("unslug", UnSlug);
Vue.filter("length", Length);
Vue.filter("date_and_time", TimeAndDate);
Vue.filter("past_tense", PastTense);
Vue.filter("friendy_type", FriendlyType);
Vue.filter("format_date_time", FormatDateTime);
Vue.filter("truncate", Truncate);

Vue.mixin({
	data: function() {
		return provider.get();
	}
});

router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
	if (requiresAuth && !localStorage.getItem("apollo-token") && process.env.VUE_APP_EDUSYNC_BYPASS_AUTH != "true") {
		next({ name: "login" });
	} else {
		next();
	}
});

router.beforeEach((to, from, next) => {
	const requiresShard = to.matched.some(record => record.meta.requiresShard);
	if (requiresShard && !localStorage.getItem("graphql-region")) {
		next({ name: "region" });
	} else {
		next();
	}
});

Vue.config.productionTip = false;
window.gql = gql;

Bugsnag.start({
	apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
	releaseStage: process.env.NODE_ENV || "development",
});

/* eslint-disable no-new */
new Vue({
	router,
	apolloProvider: createProvider(),
	render: h => h(App)
}).$mount("#app");
